import { render, staticRenderFns } from "./ShiftsContent.vue?vue&type=template&id=35472394&scoped=true&"
import script from "./ShiftsContent.vue?vue&type=script&lang=js&"
export * from "./ShiftsContent.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsContent.vue?vue&type=style&index=0&id=35472394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35472394",
  null
  
)

export default component.exports